import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";
import { API_URLS } from "../../api/apiUrls";
import { postApi } from "../../api/api_instance";
// ─── Async Thunks ──────────────────────────────────────────────────────────

// Maps internal structure ID to the API enum value
// Ab hum component se seedha backend enum ("location-first"/"department-first") bhej rahe hain
export const setOrgMode = createAsyncThunk(
  "organizationSetup/setOrgMode",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(API_URLS.ORG_MODE, {
        orgStructureMode: payload.orgStructureMode,
        reportingYearType: payload.reportingYearType,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to set organization mode",
      );
    }
  },
);

//---GET LOCATIONS------------------
export const fetchAllLocations = createAsyncThunk(
  "group/fetchAllLocations",
  async (_, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_LOCATIONS_OF_CLIENT;
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch location";
      return rejectWithValue(message);
    }
  },
);

//---ADD LOCATION--------------------
export const createLocation = createAsyncThunk(
  "group/createLocation",
  async ({ formData }, { rejectWithValue }) => {
    try {
      const url = API_URLS.CREATE_LOCATION;
      const response = await axiosInstance.post(url, formData);
      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create location";
      return rejectWithValue(message);
    }
  },
);

//---Update Location-------------------
export const updateLocation = createAsyncThunk(
  "group/updateLocation",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        API_URLS.UPDATE_LOCATION(id),
        payload,
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to update location",
      );
    }
  },
);

//---Delete Location-------------------
export const deleteLocation = createAsyncThunk(
  "group/deleteLocation",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(API_URLS.DELETE_LOCATION(id));
      return { id, message: response.data?.message };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete location",
      );
    }
  },
);
//---GET DEPARTMENT------------------
export const fetchAllDepartments = createAsyncThunk(
  "group/fetchAllDepartments",
  async (_, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_DEPARTMENT;
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch department";
      return rejectWithValue(message);
    }
  },
);
//---Update Department---------------------
export const updateDepartment = createAsyncThunk(
  "group/updateDepartment",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        API_URLS.UPDATE_DEPARTMENT(id),
        payload,
      );
      return { id, payload, message: response.data?.message };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to update department",
      );
    }
  },
);

//---Delete Department-------------------
export const deleteDepartment = createAsyncThunk(
  "group/deleteDepartment",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(
        API_URLS.DELETE_DEPARTMENT(id),
      );
      return { id, message: response.data?.message };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to delete department",
      );
    }
  },
);

//---GET LINKED ITEMS------------------
export const fetchLinkedItems = createAsyncThunk(
  "organizationSetup/fetchLinkedItems",
  async (parentId, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_DEPARTMENTS(parentId);
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch unlinked items",
      );
    }
  },
);
//----CREATE MAPPING-----------------
export const createMapping = createAsyncThunk(
  "group/createMapping",
  async (payload, { rejectWithValue }) => {
    try {
      const url = API_URLS.CREATE_MAPPING;
      const { mappingContext, ...mappingPayload } = payload || {};

      const response = await axiosInstance.post(url, mappingPayload);

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to create mapping";

      return rejectWithValue(message);
    }
  },
);
//----Link-----------------
export const fetchDepartmentLinkedEntities = createAsyncThunk(
  "group/fetchDepartmentLinkedEntities",
  async ({ id }, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_LINKED(id);
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch linked department";
      return rejectWithValue(message);
    }
  },
);
//----Unlink------------------
export const fetchDepartmentUnlinkedEntities = createAsyncThunk(
  "group/fetchDepartmentUnlinkedEntities",
  async (_, { rejectWithValue }) => {
    try {
      const url = API_URLS.GET_UNLINKED;
      const response = await axiosInstance.get(url);
      return response.data.data;
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to fetch unlinked department";
      return rejectWithValue(message);
    }
  },
);
//---GET UNLINKED ITEMS------------------
export const fetchUnlinkedItems = createAsyncThunk(
  "organizationSetup/fetchUnlinkedItems",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(API_URLS.GET_UNLINKED);
      return response.data.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Failed to fetch unlinked items",
      );
    }
  },
);

// Async thunk for creating a department
export const createDepartment = createAsyncThunk(
  "department/createDepartment",
  async (departmentData, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_DEPARTMENT,
        data: departmentData,
      });

      if (response.success) {
        return response;
      } else {
        return rejectWithValue(
          response.message || "Failed to create department",
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  },
);
//Upload Location
export const uploadCsv = createAsyncThunk(
  "location/uploadCsv",
  async (data, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.UPLOAD_CSV,
        data: data,
      });

      if (response.success) {
        return response;
      } else {
        return rejectWithValue(
          response.message || "Failed to validate location",
        );
      }
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  },
);
//Validate Location
export const validateMapping = createAsyncThunk(
  "location/validateMapping",
  async (data, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.VALIDATE_MAPPING,
        data: data,
      });

      if (response.success) {
        return response;
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  },
);
//Import Location
export const importLocation = createAsyncThunk(
  "location/importLocation",
  async (data, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.BULK_LOCATION_IMPORT,
        data: data,
      });

      if (response.success) {
        return response;
      } else {
        return rejectWithValue(response.message || "Failed to import location");
      }
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  },
);
//Import Department
export const importDepartment = createAsyncThunk(
  "department/importDepartment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.UPLOAD_DEPARTMENT_CSV,
        data: data,
      });

      if (response.success) {
        return response;
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  },
);
export const validateDepartment = createAsyncThunk(
  "department/validateDepartment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.VALIDATE_DEPARTMENT,
        data: data,
      });

      if (response.success) {
        return response;
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  },
);
export const bulkImportDepartment = createAsyncThunk(
  "department/bulkImportDepartment",
  async (data, { rejectWithValue }) => {
    try {
      const response = await postApi({
        apiUrl: API_URLS.BULK_DEPARTMENT_IMPORT,
        data: data,
      });

      if (response.success) {
        return response;
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  },
);
// ─── Initial State ─────────────────────────────────────────────────────────

const initialState = {
  currentPage: 1,
  pageSize: 5,
  search: "",
  loading: false,
  error: null,
  validationError: null,
  importError: null,
  orgMode: null, // "location-first" | "department-first"
  orgModeLocked: false,
  orgModeSuccess: false,
  locationList: [],
  departmentList: [],
  departments: [],
  newLocation: [],
  departmentUnderLocation: [],
  linkedItems: [],
  unlinkedItems: [],

  validateMappingData: [],
  importDepartmentData: [],
  validateDepartmentData: [],
  uploadCsvData: [],

  selectedLocationId: null,
  selectedDepartment: null,
  unlinkedEntities: [],
  linkedDepartments: [],
  linkedEntitiesData: [],
  importLocationData: [],
  loadingParams: {
    fetchLocation: false,
    createLocation: false,
    fetchDepartments: false,
    updateDepartments: false,
    LinkedEntities: false,
    mappingLoading: false,
    linkedLoading: false,
    unlinkedLoading: false,
    unlinkedEntitiesLoading: false,
    fetchLinked: false,
    fetchUnlinked: false,
    createMapping: false,
    mappingData: false,
    departmentImport: false,
    csvUpload: false,
    departmentValidate: false,
    loadingLocation: false,
    bulkImportLoad: false,
  },
  mappingSuccess: false,
  mappingError: null,
  mappingContext: null,
  departmentSuccess: false,
  bulkImportError: false,
  bulkDepartmentData: [],
};

// ─── Slice ────────────────────────────────────────────────────────────────

const organizationsetupSlice = createSlice({
  name: "organizationSetup",
  initialState,
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
      state.currentPage = 1;
    },
    clearSetupError(state) {
      state.error = null;
    },
    resetOrgModeStatus(state) {
      state.orgModeSuccess = false;
      state.error = null;
    },
    setSelectedLocationId(state, action) {
      state.selectedLocationId = action.payload;
    },

    setSelectedDepartment: (state, action) => {
      state.selectedDepartment = action.payload;
    },
    clearMappingStatus: (state) => {
      state.mappingSuccess = false;
      state.mappingError = null;
      state.mappingContext = null;
      state.error = null;
    },
    clearDepartmentStatus: (state) => {
      state.departmentSuccess = false;
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      // Set Org Mode
      .addCase(setOrgMode.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.orgModeSuccess = false;
      })
      .addCase(setOrgMode.fulfilled, (state, action) => {
        state.loading = false;
        state.orgModeSuccess = true;
        state.orgModeLocked = true;
        // API response ya triggered action argument se value store mein set kar rhe hain
        state.orgMode =
          action.payload?.data?.orgStructureMode ||
          action.meta.arg?.orgStructureMode;
        state.reportingYearType =
          action.payload?.data?.reportingYearType ||
          action.meta.arg?.reportingYearType;
      })
      .addCase(setOrgMode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //Fetch locations
      .addCase(fetchAllLocations.pending, (state) => {
        state.loadingParams.fetchLocation = true;
        state.error = null;
      })
      .addCase(fetchAllLocations.fulfilled, (state, action) => {
        state.loadingParams.fetchLocation = false;
        state.locationList = action.payload ?? [];
      })
      .addCase(fetchAllLocations.rejected, (state, action) => {
        state.loadingParams.fetchLocation = false;
        state.error = action.payload;
        state.locationList = [];
      })
      //Create Location
      .addCase(createLocation.pending, (state) => {
        state.loadingParams.createLocation = true;
        state.error = null;
      })
      .addCase(createLocation.fulfilled, (state, action) => {
        state.loadingParams.createLocation = false;

        const newLocation = action.payload?.data;

        if (newLocation) {
          state.locationList.push(newLocation);
        }
      })
      .addCase(createLocation.rejected, (state, action) => {
        state.loadingParams.createLocation = false;
        state.error = action.payload;
        state.newLocation = [];
      })
      //update location
      .addCase(updateLocation.pending, (state) => {
        state.loadingParams.updateLocation = true;
        state.error = null;
      })
      .addCase(updateLocation.fulfilled, (state, action) => {
        state.loadingParams.updateLocation = false;

        const updatedLocation = action.payload.data;

        const index = state.locationList.findIndex(
          (loc) => loc._id === updatedLocation._id,
        );

        if (index !== -1) {
          state.locationList[index] = updatedLocation;
        }
      })
      .addCase(updateLocation.rejected, (state, action) => {
        state.loadingParams.updateLocation = false;
        state.error = action.payload;
      })
      //Delete location
      .addCase(deleteLocation.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.locationList = state.locationList.filter(
          (location) => location._id !== id,
        );
      })
      //Fetch departments
      .addCase(fetchAllDepartments.pending, (state) => {
        state.loadingParams.fetchDepartments = true;
        state.error = null;
      })
      .addCase(fetchAllDepartments.fulfilled, (state, action) => {
        state.loadingParams.fetchDepartments = false;
        state.departmentList = action.payload ?? [];
      })
      .addCase(fetchAllDepartments.rejected, (state, action) => {
        state.loadingParams.fetchDepartments = false;
        state.error = action.payload;
        state.departmentList = [];
      })
      //Update department
      .addCase(updateDepartment.pending, (state) => {
        state.loadingParams.updateDepartments = true;
        state.error = null;
      })
      .addCase(updateDepartment.fulfilled, (state, action) => {
        state.loadingParams.updateDepartments = false;

        const { id, payload } = action.payload;

        const index = state.departmentList.findIndex((loc) => loc._id === id);

        if (index !== -1) {
          state.departmentList[index] = {
            ...state.departmentList[index],
            ...payload,
          };
        }
      })
      .addCase(updateDepartment.rejected, (state, action) => {
        state.loadingParams.updateDepartments = false;
        state.error = action.payload;
      })
      //Delete location
      .addCase(deleteDepartment.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.departmentList = state.departmentList.filter(
          (department) => department._id !== id,
        );
      })
      //mapping
      .addCase(createMapping.pending, (state, action) => {
        state.loadingParams.mappingLoading = true;
        state.loadingParams.createMapping = true;
        state.mappingSuccess = false;
        state.mappingError = null;
        state.mappingContext = action.meta.arg?.mappingContext || null;
      })

      .addCase(createMapping.fulfilled, (state, action) => {
        state.loadingParams.mappingLoading = false;
        state.loadingParams.createMapping = false;
        const isMappingSuccess = action.payload?.success !== false;
        state.mappingSuccess = isMappingSuccess;
        state.mappingError = isMappingSuccess
          ? null
          : action.payload?.message || "Failed to create mapping";
        const mappingContext = action.meta.arg?.mappingContext;
        state.mappingContext = mappingContext || null;

        if (!isMappingSuccess) {
          return;
        }

        const newMappings = action.payload?.data ?? action.payload ?? [];
        const parentId = action.meta.arg?.parentId;
        const mappingCount = Array.isArray(newMappings)
          ? newMappings.length
          : 1;

        if (mappingContext === "departmentLocations") {
          const departmentIndex = state.departmentList.findIndex(
            (department) => department._id === parentId,
          );

          if (departmentIndex !== -1) {
            state.departmentList[departmentIndex].linkedLocationCount =
              (state.departmentList[departmentIndex].linkedLocationCount || 0) +
              mappingCount;
          }
        }

        if (mappingContext === "locationDepartments") {
          const locationIndex = state.locationList.findIndex(
            (location) => location._id === parentId,
          );

          if (locationIndex !== -1) {
            state.locationList[locationIndex].linkedDepartmentCount =
              (state.locationList[locationIndex].linkedDepartmentCount || 0) +
              mappingCount;
          }
        }

        if (Array.isArray(newMappings)) {
          state.linkedEntitiesData.push(...newMappings);
        } else {
          state.linkedEntitiesData.push(newMappings);
        }
      })

      .addCase(createMapping.rejected, (state, action) => {
        state.loadingParams.mappingLoading = false;
        state.loadingParams.createMapping = false;
        state.mappingSuccess = false;
        state.mappingError = action.payload;
        state.mappingContext = action.meta.arg?.mappingContext || null;
        state.error = action.payload;
      })
      //Fetch linked department
      .addCase(fetchDepartmentLinkedEntities.pending, (state) => {
        state.loadingParams.LinkedEntities = true;
        state.error = null;
      })

      .addCase(fetchDepartmentLinkedEntities.fulfilled, (state, action) => {
        state.loadingParams.LinkedEntities = false;
        state.linkedDepartments = action.payload;
      })

      .addCase(fetchDepartmentLinkedEntities.rejected, (state, action) => {
        state.loadingParams.LinkedEntities = false;
        state.error = action.payload;
      })
      // .addCase(createMapping.fulfilled, (state, action) => {
      //   state.loadingParams.createMapping = false;
      //   state.mappingSuccess = true;
      // })
      // .addCase(createMapping.rejected, (state, action) => {
      //   state.loadingParams.createMapping = false;
      //   state.error = action.payload;
      // })
      //Fetch unlinked department
      .addCase(fetchDepartmentUnlinkedEntities.pending, (state) => {
        state.loadingParams.unlinkedEntitiesLoading = true;
        state.unlinkedEntitiesError = null;
      })

      .addCase(fetchDepartmentUnlinkedEntities.fulfilled, (state, action) => {
        state.loadingParams.unlinkedEntitiesLoading = false;
        state.unlinkedEntities = action.payload;
      })

      .addCase(fetchDepartmentUnlinkedEntities.rejected, (state, action) => {
        state.loadingParams.unlinkedEntitiesLoading = false;
        state.unlinkedEntitiesError =
          action.payload || "Failed to fetch unlinked entities";
      })
      //Fetch linked items
      .addCase(fetchLinkedItems.pending, (state) => {
        state.loadingParams.fetchLinked = true;
        state.error = null;
      })
      .addCase(fetchLinkedItems.fulfilled, (state, action) => {
        state.loadingParams.fetchLinked = false;
        state.linkedItems = action.payload ?? [];
      })
      .addCase(fetchLinkedItems.rejected, (state, action) => {
        state.loadingParams.fetchLinked = false;
        state.error = action.payload;
      })
      //Fetch unlinked items
      .addCase(fetchUnlinkedItems.pending, (state) => {
        state.loadingParams.fetchUnlinked = true;
        state.error = null;
      })
      .addCase(fetchUnlinkedItems.fulfilled, (state, action) => {
        state.loadingParams.fetchUnlinked = false;
        state.unlinkedItems = action.payload ?? [];
      })
      .addCase(fetchUnlinkedItems.rejected, (state, action) => {
        state.loadingParams.fetchUnlinked = false;
        state.error = action.payload;
      })

      // Create Department
      .addCase(createDepartment.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.departmentSuccess = false;
      })
      .addCase(createDepartment.fulfilled, (state, action) => {
        state.loading = false;
        state.departmentSuccess = true;

        const responseData = action.payload?.data;
        const createdDepartments = Array.isArray(responseData?.departments)
          ? responseData.departments
          : Array.isArray(responseData)
            ? responseData
            : [];

        if (createdDepartments.length) {
          const normalizedCreatedDepartments = createdDepartments.map(
            (dept) => ({
              name: dept?.name,
              isActive: dept?.isActive,
              ...(dept?._id ? { _id: dept._id } : {}),
            }),
          );

          state.departmentList = [
            ...state.departmentList,
            ...normalizedCreatedDepartments,
          ];
        }
      })
      .addCase(createDepartment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.departmentSuccess = false;
      })

      //Validate location

      .addCase(uploadCsv.pending, (state) => {
        state.error = null;
        state.loadingParams.csvUpload = true;
        state.uploadCsvData = [];
      })
      .addCase(uploadCsv.fulfilled, (state, action) => {
        state.loadingParams.csvUpload = false;
        state.uploadCsvData = action.payload ?? [];
      })
      .addCase(uploadCsv.rejected, (state, action) => {
        state.error = action.payload;
        state.loadingParams.csvUpload = false;
        state.uploadCsvData = [];
      })
      //Import location
      .addCase(validateMapping.pending, (state) => {
        state.error = null;
        state.loadingParams.mappingData = true;
        state.validateMappingData = [];
      })
      .addCase(validateMapping.fulfilled, (state, action) => {
        state.loadingParams.mappingData = false;
        state.validateMappingData = action.payload ?? [];
      })
      .addCase(validateMapping.rejected, (state, action) => {
        state.loadingParams.mappingData = false;
        state.error = action.payload;
        state.validateMappingData = [];
      })
      //Import location
      .addCase(importLocation.pending, (state) => {
        state.error = null;
        state.loadingParams.loadingLocation = true;
        state.importLocationData = [];
      })
      .addCase(importLocation.fulfilled, (state, action) => {
        state.loadingParams.loadingLocation = false;
        state.importLocationData = action.payload ?? [];
      })
      .addCase(importLocation.rejected, (state, action) => {
        state.loadingParams.loadingLocation = false;
        state.error = action.payload;
        state.importLocationData = [];
      })

      //Import Department
      .addCase(importDepartment.pending, (state) => {
        state.loadingParams.departmentImport = true;
        state.importError = null;
        state.importDepartmentData = [];
      })
      .addCase(importDepartment.fulfilled, (state, action) => {
        state.loadingParams.departmentImport = false;
        state.importDepartmentData = action.payload ?? [];
      })
      .addCase(importDepartment.rejected, (state, action) => {
        state.importError = action.payload;
        state.loadingParams.departmentImport = false;
        state.importDepartmentData = [];
      })

      //Validate Department
      .addCase(validateDepartment.pending, (state) => {
        state.validationError = null;
        state.loadingParams.departmentValidate = true;
        state.validateDepartmentData = [];
      })
      .addCase(validateDepartment.fulfilled, (state, action) => {
        state.loadingParams.departmentValidate = false;
        state.validateDepartmentData = action.payload ?? [];
      })
      .addCase(validateDepartment.rejected, (state, action) => {
        state.loadingParams.departmentValidate = false;
        state.validationError = action.payload;
        state.validateDepartmentData = [];
      })
      //Import Bulk Department
      .addCase(bulkImportDepartment.pending, (state) => {
        state.bulkImportError = null;
        state.loadingParams.bulkImportLoad = true;
        state.bulkDepartmentData = [];
      })
      .addCase(bulkImportDepartment.fulfilled, (state, action) => {
        state.loadingParams.bulkImportLoad = false;
        state.bulkDepartmentData = action.payload ?? [];
      })
      .addCase(bulkImportDepartment.rejected, (state, action) => {
        state.loadingParams.bulkImportLoad = false;
        state.bulkImportError = action.payload;
        state.bulkDepartmentData = [];
      });
  },
});

export const {
  setCurrentPage,
  setPageSize,
  setSearch,
  clearSetupError,
  resetOrgModeStatus,
  setSelectedLocationId,
  setSelectedDepartment,
  clearMappingStatus,
  clearDepartmentStatus,
} = organizationsetupSlice.actions;

export default organizationsetupSlice.reducer;
